import { Divider, GeneralCloseIcon } from '@outdoorsyco/bonfire';
import React from 'react';
import { useIntl } from 'react-intl';

import Button, {
  ButtonShape,
  ButtonSize,
  ButtonVariants,
} from '@/components/switchback/Button/Button';
import Heading from '@/components/switchback/Heading/Heading';

interface IProps {
  className?: string;
  title?: string;
  href: string;
}

const AllReviewsHeader: React.FC<IProps> = ({ className, title = '', href }) => {
  const intl = useIntl();

  return (
    <>
      <div data-testid="all-reviews-page-header" className={className}>
        <div className="flex items-center justify-between py-6 md:py-8 col-start-content col-end-content">
          <Heading data-testid="all-reviews-page-title" className="highlight autoType800" level={1}>
            {title}
          </Heading>
          <Button
            testid="close-btn"
            aria-label={intl.formatMessage({ defaultMessage: 'Back', id: 'cyR7Kh' })}
            href={href}
            shape={ButtonShape.circle}
            variant={ButtonVariants.lightPrimaryOutlined}
            size={ButtonSize.small}
            forceClientsideRouting>
            <GeneralCloseIcon className="text-gray-900" fontSize={18} />
          </Button>
        </div>
      </div>
      <Divider />
    </>
  );
};

export default AllReviewsHeader;
